import { RadioAvatarCard } from 'components/Form/RadioAvatarCard/RadioAvatarCard';
import { Moment } from 'moment-timezone';
import React from 'react';
import { Staff } from 'types/Staff';

interface StaffRadioCardProps {
    staff: Staff;
    dateFormat: string;
    loading?: boolean;
    disabled?: boolean;
    selected?: boolean;
    busyForWeeks?: number;
    availableAt?: Moment;
    description?: string | React.ReactNode;
    onSelected?: () => void;
}

export const StaffRadioCard: React.FC<StaffRadioCardProps> = props => {
    const description = React.useMemo(() => {
        if (props.loading && props.description === undefined) {
            return <>&nbsp;</>;
        }

        if (props.description !== undefined) {
            return props.description;
        }

        if (props.busyForWeeks) {
            return `Busy for ${props.busyForWeeks} weeks`;
        }

        if (props.availableAt) {
            return (
                <>
                    Available: <b>{props.availableAt.format(props.dateFormat)}</b>
                </>
            );
        }

        return <>&nbsp;</>;
    }, [props.busyForWeeks, props.availableAt, props.loading, props.description, props.dateFormat]);

    return (
        <div>
            <RadioAvatarCard
                loading={props.loading}
                disabled={props.disabled}
                label={props.staff.name}
                description={description}
                avatar={props.staff.avatar}
                checked={props.selected}
                onChange={props.onSelected}
            />
        </div>
    );
};
